// extracted by mini-css-extract-plugin
export var messageSideLeft = "_k7-1";
export var messageSideRight = "_k7-2";
export var subscribeToBackInStockBubbleContainer = "_k7-0";